// extracted by mini-css-extract-plugin
module.exports = {"previewTable":"RedeemTrxQr_previewTable__1z3J_","previewItem":"RedeemTrxQr_previewItem__2YuPu","successMessage":"RedeemTrxQr_successMessage__1yiuT"};